// Document rules applied to every traveller form, whichever module it belongs to.
import { parseIso, toIso, todayIso } from '../data/common';

const PASSPORT_FIELDS = ['passport', 'passportExpiry', 'nationality'];

const shift = (iso, { years = 0, months = 0, days = 0 }) => {
  const d = parseIso(iso);
  d.setFullYear(d.getFullYear() + years, d.getMonth() + months, d.getDate() + days);
  return toIso(d);
};

/**
 * Final field list for a traveller:
 * - Children and infants need a date of birth (domestic and international), unless the spec sets
 *   dobRequired: false because the age is already known (e.g. hotel rooms are priced by child age).
 * - International trips need date of birth + passport number, expiry and nationality for everyone.
 */
export function resolveFields(spec, international) {
  const fields = [...spec.fields];
  const add = (k) => { if (!fields.includes(k)) fields.push(k); };
  if ((spec.type === 'Child' || spec.type === 'Infant') && spec.dobRequired !== false) add('dob');
  if (international) { add('dob'); PASSPORT_FIELDS.forEach(add); }
  return fields;
}

/**
 * Allowed date-of-birth range so the age on the travel date matches the traveller type.
 * Child: 2–12 years · Infant: under 2 years · Adult: 12 years or older.
 * A spec can override this with its own dobMin / dobMax (e.g. insurance age limits).
 */
export function dobRange(spec, travelDate) {
  const ref = travelDate || todayIso();
  const today = todayIso();
  if (spec.dobMin || spec.dobMax) return { min: spec.dobMin, max: spec.dobMax, hint: spec.dobHint };
  if (spec.type === 'Infant') return { min: shift(ref, { years: -2, days: 1 }), max: today, hint: 'Must be under 2 years on the travel date' };
  if (spec.type === 'Child') return { min: shift(ref, { years: -12, days: 1 }), max: shift(ref, { years: -2 }), hint: 'Must be 2–12 years on the travel date' };
  return { min: shift(ref, { years: -100 }), max: shift(ref, { years: -12 }), hint: 'Must be 12 years or older' };
}

/** Passport must be valid for at least 6 months after the trip ends. */
export const passportMinExpiry = (travelEnd) => shift(travelEnd || todayIso(), { months: 6 });

export { shift as shiftIso };
